export default {
  site_name: '午马影院',
  site_slogan: '高清不缓冲 · 免费在线看',
  nav_home: '首页',
  nav_category: '分类',
  nav_about: '关于我们',
  hero_title: '海量高清影视，即点即播不卡顿',
  hero_subtitle: '高清不缓冲免费在线看，流畅播放免费视频高清影视，免注册即点即看',
  hot_recommend: '热门推荐',
  latest_update: '最新更新',
  view_detail: '查看详情',
  view_all: '查看全部',
  category_movie: '电影',
  category_tv: '电视剧',
  category_variety: '综艺',
  category_anime: '动漫',
  category_doc: '纪录片',
  rating: '评分',
  year: '年份',
  director: '导演',
  actors: '主演',
  description: '简介',
  back_to_top: '回到顶部',
  footer_copyright: '© 2024 午马影院 版权所有',
  footer_disclaimer: '本站所有内容均来自互联网，仅供学习交流使用',
  about_title: '关于午马影院',
  about_brand: '品牌介绍',
  about_reputation: '口碑声誉',
  about_contact: '联系我们',
  contact_address: '地址',
  contact_phone: '电话',
  contact_email: '邮箱',
  breadcrumb_home: '首页',
  related_videos: '相关推荐',
  no_results: '暂无相关内容',
  search_placeholder: '搜索你想看的电影、剧集...',
  tag_hot: '热播',
  tag_new: '最新',
  tag_hd: '高清',
};